export default __webpack_public_path__ + "static/media/FeIcon3.8da08327.svg";